
import { Check, Close } from '@mui/icons-material'
import { FormControl, IconButton, MenuItem, Select } from '@mui/material'
import { useEffect, useState } from 'react'
import { BioChild, FormattedBioBox } from '../types'
import '../BiologicalMonitoring.css'
import { ChildPracticeMetadata } from '../../../../types'

interface PracticeAssignmentProps {
  childPractices: ChildPracticeMetadata[]
  bioBox: FormattedBioBox | null
  updateBoxPractice: (assignedPractice: ChildPracticeMetadata, bioBox: FormattedBioBox) => void
  onClose: () => void
}

const buttonStyles = {
  borderRadius: '4px',
  marginLeft: '5px'
}

const iconStyles = {
  fontSize: '10px'
}

const PracticeAssignment = ({ childPractices, bioBox, updateBoxPractice, onClose }: PracticeAssignmentProps) => {
  const [assignedPractice, setAssignedPractice] = useState<ChildPracticeMetadata>({ customer_number: '' } as unknown as ChildPracticeMetadata)

  const handleChangePractice = (customerNumber: string) => {
    const newValue = childPractices.find(p => p.customer_number === customerNumber)
    if (newValue) setAssignedPractice(newValue)
  }

  const getCurrentPractice = () => {
    const matchedPractice = childPractices?.filter(practice => {
      return practice.customer_number === bioBox?.customer_number
    })
    const practice = matchedPractice.length === 1 ? matchedPractice[0] : { customer_number: bioBox?.customer_number, name: bioBox?.name } as ChildPracticeMetadata
    setAssignedPractice(practice)
  }

  useEffect(() => {
    if (bioBox && childPractices) {
      getCurrentPractice()
    }
  }, [childPractices, bioBox])

  const handleSave = () => {
    if (assignedPractice && bioBox) {
      updateBoxPractice(assignedPractice, bioBox)
    }
  }

  const handleClose = () => {
    getCurrentPractice()
    onClose()
  }

  return (

    <div className='flex practice-assignment-wrapper'>
      <FormControl size='small' sx={{ height: '30px' }}>
        <Select
          sx={{ height: '30px', width: '400px', backgroundColor: 'white' }}
          value={assignedPractice?.customer_number}
          onChange={(e) => handleChangePractice(e.target.value)}
          size='small'
          slotProps={{
            input: {
              sx: {
                fontSize: '13px'
              }
            }
          }}
        >
          {childPractices
            .slice()
            .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''))
            .map(practice => (
              <MenuItem
                key={practice.customer_number}
                value={practice.customer_number}
              >
                {practice.name} #{practice.customer_number}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      <div>
        <IconButton
          size='small'
          onClick={handleSave}
          sx={{ ...buttonStyles, backgroundColor: '#0086b7' }}
        >
          <Check
            sx={{ ...iconStyles, color: 'white' }}
          />
        </IconButton>
        <IconButton
          size='small'
          sx={{ ...buttonStyles, backgroundColor: 'white', border: '1px solid #0086b7' }}
          onClick={handleClose}
        >
          <Close
            sx={{ ...iconStyles, color: '#0086b7' }}
          />
        </IconButton>
      </div>
    </div>
  )
}

export default PracticeAssignment